import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import useFilters from '../../hooks/useFilters';

dayjs.extend(utc);

const useGetReportsState = () => {
  const [filters, setFilter] = useFilters();

  const startDate = dayjs(filters?.start || '')
    .local()
    .toDate();
  const endDate = dayjs(filters?.end || '')
    .local()
    .toDate();

  return {
    setFilter,
    startDate,
    endDate,
  };
};

export default useGetReportsState;
